import { render } from "./TalentDetails.vue?vue&type=template&id=629d827b"
import script from "./TalentDetails.vue?vue&type=script&lang=js"
export * from "./TalentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__